import { ApiService } from "./ApiService";
import type {
  SourceControl,
  SourceControlProvider,
} from "@shared/types/ServiceOrderDto";

export interface IntegrationInstallation {
  id: string;
  provider: SourceControlProvider;
  accountName: string;
  accountId: string;
  installedAt: string;
  repositories: string[];
}

export interface ConnectRepoPayload {
  serviceOrderId: string;
  provider: SourceControlProvider;
  repo: string;
  installationId: string;
}

export class IntegrationsService {
  constructor(private apiService: ApiService) {}

  async getInstallations(): Promise<IntegrationInstallation[]> {
    return this.apiService.request<IntegrationInstallation[]>(
      "/integrations/installations",
      { requireAuth: true }
    );
  }

  async getInstallationUrl(
    provider: SourceControlProvider,
    serviceOrderId: string
  ): Promise<{ url: string }> {
    return this.apiService.request<{ url: string }>(
      `/integrations/${provider}/install-url/${serviceOrderId}`,
      { requireAuth: true }
    );
  }

  async connectRepoToProject(
    payload: ConnectRepoPayload
  ): Promise<SourceControl> {
    return this.apiService.request<SourceControl>("/integrations/connect", {
      method: "POST",
      body: JSON.stringify(payload),
      requireAuth: true,
    });
  }

  async disconnectRepo(serviceOrderId: string): Promise<void> {
    return this.apiService.request<void>(
      `/integrations/disconnect/${serviceOrderId}`,
      {
        method: "DELETE",
        requireAuth: true,
      }
    );
  }

  async getAvailableRepos(
    provider: SourceControlProvider,
    installationId: string
  ): Promise<{ repos: string[] }> {
    return this.apiService.request<{ repos: string[] }>(
      `/integrations/${provider}/repos`,
      {
        params: { installationId },
        requireAuth: true,
      }
    );
  }
}
